module.exports = __webpack_public_path__ + "6bc854d06dc4622561c6e0f6bf0f028e.jpg";